export default [
  { name_en: 'China',
    name: '中国',
    code: 86,
    index: 'Z',
    index_en: 'C' },
  { name_en: 'Hongkong',
    name: '中国香港',
    code: 852,
    index: 'X',
    index_en: 'H' },
  { name_en: 'Taiwan',
    name: '中国台湾',
    code: 886,
    index: 'T',
    index_en: 'T' },
  { name_en: 'Macao',
    name: '中国澳门',
    code: 853,
    index: 'A',
    index_en: 'M' },
  { name_en: 'United Kiongdom',
    name: '英国',
    code: 44,
    index: 'Y',
    index_en: 'U' },
  { name_en: 'United States of America',
    name: '美国',
    code: 1,
    index: 'M',
    index_en: 'U' },
  { name_en: 'Canada',
    name: '加拿大',
    code: 1,
    index: 'J',
    index_en: 'C' },
  { name_en: 'Malaysia',
    name: '马来西亚',
    code: 60,
    index: 'M',
    index_en: 'A' },
  { name_en: 'Australia',
    name: '澳大利亚',
    code: 61,
    index: 'A',
    index_en: 'A' },
  { name_en: 'Austria',
    name: '奥地利',
    code: 43,
    index: 'A',
    index_en: 'A' },
  { name_en: 'Belgium',
    name: '比利时',
    code: 32,
    index: 'B',
    index_en: 'B' },
  { name_en: 'Denmark',
    name: '丹麦',
    code: 45,
    index: 'D',
    index_en: 'D' },
  { name_en: 'Finland',
    name: '芬兰',
    code: 358,
    index: 'F',
    index_en: 'F' },
  { name_en: 'France',
    name: '法国',
    code: 33,
    index: 'F',
    index_en: 'F' },
  { name_en: 'Germany',
    name: '德国',
    code: 49,
    index: 'D',
    index_en: 'G' },
  { name_en: 'Hungary',
    name: '匈牙利',
    code: 36,
    index: 'X',
    index_en: 'H' },
  { name_en: 'Italy',
    name: '意大利',
    code: 39,
    index: 'Y',
    index_en: 'I' },
  { name_en: 'Japan',
    name: '日本',
    code: 81,
    index: 'R',
    index_en: 'J' },
  { name_en: 'Korea',
    name: '韩国',
    code: 82,
    index: 'H',
    index_en: 'K' },
  { name_en: 'Netherlands',
    name: '荷兰',
    code: 31,
    index: 'H',
    index_en: 'N' },
  { name_en: 'New Zealand',
    name: '新西兰',
    code: 64,
    index: 'X',
    index_en: 'N' },
  { name_en: 'Norway',
    name: '挪威',
    code: 47,
    index: 'N',
    index_en: 'N' },
  { name_en: 'Portugal',
    name: '葡萄牙',
    code: 351,
    index: 'P',
    index_en: 'P' },
  { name_en: 'Russia',
    name: '俄罗斯',
    code: 7,
    index: 'E',
    index_en: 'R' },
  { name_en: 'Saudi Arabia',
    name: '沙特阿拉伯',
    code: 966,
    index: 'S',
    index_en: 'S' },
  { name_en: 'Singapore',
    name: '新加坡',
    code: 65,
    index: 'X',
    index_en: 'S' },
  { name_en: 'South Africa',
    name: '南非',
    code: 27,
    index: 'N',
    index_en: 'S' },
  { name_en: 'Spain',
    name: '西班牙',
    code: 34,
    index: 'X',
    index_en: 'S' },
  { name_en: 'Sweden',
    name: '瑞典',
    code: 46,
    index: 'R',
    index_en: 'S' },
  { name_en: 'Switzerland',
    name: '瑞士',
    code: 41,
    index: 'R',
    index_en: 'S' }
]

